import {
  Box, Button, Switch, Typography
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

import SelectorBox from './SelectorBox';
import ParameterBox from './ParameterBox';
import { useDashboardContext } from '../../../components/providers/DashboardProvider';

const ControlPage: React.FC = ({
}) => {

  const essModeOptions = [
    {
      name: "Export Only",
      value: "export_only"
    },
    {
      name: "Import Only",
      value: "import_only"
    },
    {
      name: "No Restriction",
      value: "no_restriction"
    },
    {
      name: "No Exchange",
      value: "no_exchange"
    }
  ];

  const setpointModeOptions = [
    {
      name: "Local manual",
      value: "local_manual"
    },
    {
      name: "Automatic",
      value: "automatic"
    },
  ];

  const baseUrl = "wss://en954tmwha.execute-api.us-west-1.amazonaws.com/production/";

  const {
    loading, fetchClusterComponentsTree, componentsTree, selectedCluster
  } = useDashboardContext();

  const ws = useRef<WebSocket | null>(null);

  const [essModeSelected, setEssModeSelected] = useState<string>("");
  const [essMode, setEssMode] = useState<string>("");

  const [setpointModeSelected, setSetpointModeSelected] = useState<string>("");
  const [setpointMode, setSetpointMode] = useState<string>("");

  const [isCharging, setIsCharging] = useState<boolean>(false);

  const [pending, setPending] = useState<boolean>(false);
  const [connected, setConnected] = useState<boolean>(false);
  const [response, setResponse] = useState<Record<string, unknown>>({});
  const [message, setMessage] = useState<Record<string, unknown>>({});
  const [responseWait, setResponseWait] = useState<number | null>(null);

  const [computerId, setComputerId] = useState<string>("");
  const [clusterId, setClusterId] = useState<string>("");
  const [accessToken, setAccessToken] = useState<string>("");
  const [userId, setUserId] = useState<string>("");


  function handleEssModeSelection(selection: string) {
    setEssModeSelected(selection)
  }

  function handleSetpointModeSelection(selection: string) {
    setSetpointModeSelected(selection)
  }

  function connect(): void {
    console.log("Connecting...");
    setResponse({});

    // Open connection
    setPending(true);
    ws.current = new WebSocket(
      `${baseUrl}?access_token=${accessToken}&cluster_id=${clusterId}&user_id=${userId}&computer_id=${computerId}`
    );

    ws.current.onopen = () => {
      console.log("Connected");
      setPending(false);
      setConnected(true);
      const testMessage = { command: "ping" };
      ws.current?.send(JSON.stringify({
        action: "publish",
        message: testMessage,
      }));
      setMessage(testMessage);
      setResponseWait(10);
    };

    ws.current.onmessage = (event) => {
      // console.log(event.data);
      setResponse(JSON.parse(event.data)?.payload);
      setResponseWait(null);
    };

    ws.current.onclose = () => {
      console.log("Disconnected");
      setPending(false);
      setConnected(false);
    };
  }

  function disconnect(): void {
    console.log("Disconnecting...");
    setPending(true);
    if (ws.current != null) {
      ws.current.close();
    } else {
      setConnected(false);
      setPending(false);
    }
  }


  useEffect(() => {
    fetchClusterComponentsTree();

    return () => {
      disconnect();
      setPending(false);
      setResponse({});
      // console.log("unmounting");
    };
  }, []);


  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      alignItems: "center",
      gap: 10,
      // border: 1,
    }}>

      <Box sx={{
        display: "flex",
        flexDirection: "row",
        // justifyContent: "end",
        alignItems: "end",
        width: 500,
        gap: 3,
        // border: 1,
      }}>

        <SelectorBox
          title={"Block"}
          options={essModeOptions}
          currentOption={essMode}
          onSelection={handleEssModeSelection}
          helperText={null}
        />

        <Button
          variant='contained'
          sx={{
            width: "165px",
            height: "56px",
          }}
        >
          Connect
        </Button>

      </Box>

      <Box sx={{
        display: "flex",
        flexDirection: "column",
        width: 500,
        gap: 3,
        // border: 1,
      }}>

        <SelectorBox
          title={"ESS Mode"}
          options={essModeOptions}
          currentOption={essMode}
          onSelection={handleEssModeSelection}
          helperText={null}
        />

        <ParameterBox
          title={"Grid export limit"}
          unit={"kW"}
          defaultValue={0}
        />

        <ParameterBox
          title={"Grid import limit"}
          unit={"kW"}
          defaultValue={0}
        />

        <ParameterBox
          title={"BESS charge limit"}
          unit={"kW"}
          defaultValue={0}
        />

        <ParameterBox
          title={"BESS discharge limit"}
          unit={"kW"}
          defaultValue={0}
        />
      </Box>
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        width: 500,
        marginTop: 5,
        gap: 3,
        // border: 1,
      }}>
        <SelectorBox
          title={"Power setpoint mode"}
          options={setpointModeOptions}
          currentOption={essMode}
          onSelection={handleSetpointModeSelection}
          helperText={null}
        />
        <ParameterBox
          title={"Power input setpoint"}
          unit={"kW"}
          defaultValue={0}
          prefix={isCharging ? "+" : "-"}
        />

        <Box sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}>
          <Button
            variant={isCharging ? 'contained' : 'outlined'}
            sx={{
              width: "165px"
            }}
            onClick={() => { setIsCharging(true) }}
          >
            Charge
          </Button>
          <Button
            // variant='outlined'
            variant={!isCharging ? 'contained' : 'outlined'}
            sx={{
              width: "165px"
            }}
            onClick={() => { setIsCharging(false) }}
          >
            Discharge
          </Button>
        </Box>

      </Box>

      <Button
        variant='contained'
        sx={{
          width: "165px"
        }}
      >
        Save
      </Button>


    </Box>
  )
}

export default ControlPage;